import useTranslation from 'next-translate/useTranslation';
import {
  Container,
  Wrapper,
  LotieAnimationItem,
  Description,
  Title,
  Spacer,
} from './styles.nodata';
import { useLottiePlayer } from '@starsoft/common/hooks';

export default function NoDataFound() {
  const { t } = useTranslation('common');
  const { lottieAnimationRef } = useLottiePlayer({
    path: '/bell.json',
  });

  return (
    <Container>
      <Wrapper>
        <Spacer />
        <LotieAnimationItem ref={lottieAnimationRef} />
        <Spacer />
        <Title>{t('no_notification_title')}</Title>
        <Description>{t('no_notifications_found')}</Description>
        <Spacer />
      </Wrapper>
    </Container>
  );
}
